import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import { sessionsSettingsApi } from '@hotjar/webapp/features/Settings/api';
import { useEffect } from 'react';

const ERROR_CAPTURING_CONSENT_UA_ADDED_KEY = 'error-capturing-consent-ua-added';

export const useAddErrorCapturingConsentUA = (userId?: number, siteId?: number): void => {
  useEffect(() => {
    if (!siteId || !userId) return;

    (async () => {
      // Leveraging local storage to optimaze the hook and don't check site settings every time user opens the player
      const errorCapturingConsentUAAdded = LocalStorage.get(ERROR_CAPTURING_CONSENT_UA_ADDED_KEY);
      if (errorCapturingConsentUAAdded) return;

      const response = await sessionsSettingsApi.get(siteId);
      if (response.data?.session_capture_console_consent === true) {
        LocalStorage.set(ERROR_CAPTURING_CONSENT_UA_ADDED_KEY, true);
        if (window.hj) {
          window.hj('identify', userId, { console_tracking: 'on' });
        }
      }
    })();
  }, [siteId, userId]);
};
